module["exports"] = [
  "#####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/uk/address/postcode.js
 ** module id = 1048
 ** module chunks = 0
 **/